module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_3.1079bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_3.png
// module id = WIbg
// module chunks = 0